export const DEFAULT_DATE_FORMAT = "MM/DD/YYYY";

export const DATE_FORMAT_MM_DD_YYYY_DASH = "MM-DD-YYYY";

export const INVALID_YEAR_DATE_FORMAT = "MM/DD/[xxxx]";

export const DEFAULT_DATE_TIME_FORMAT = "MM/DD/YYYY hh:mm:ss";

export const EST_ZONE = "America/New_york";

// Sample - February 16, 2024 AT 03:26 PM
export const FULL_MONTH_DATE_TIME_FORMAT = "MMMM D, YYYY [at] hh:mm A";

export const MONTH_DATE_DAY_FORMAT = "MM/DD";

export const MONTH_DATE_YEAR_DAY_FORMAT = "MM/DD/YY";
export const MONTH_DATE_YEAR_DAY_EST_FORMAT = "MM/DD/YY [EST]";
export const MONTH_DATE_YEAR_TIME_EST_FORMAT = "MM/DD/YY [at] hh:mm A [EST]";
export const MONTH_DATE_YEAR_TIME_EST_FORMAT_2 = "MM/DD/YY [at] h:mm A [EST]";
export const MONTH_DATE_YEAR_TIME_EST_FORMAT_3 = "MM/DD/YY hh:mm A [EST]";

export const HOUR_MINUTE_TIME_FORMAT = "hh:mm A";

export const YEAR_MONTH_DATE_FORMAT = "YYYY-MM-DD";

export const FULL_MONTH_DATE_FULL_YEAR_FORMAT = "MMMM DD, YYYY";

export const DEFAULT_CALENDAR_DATE_OUTPUT_FORMAT = {
  sameDay: "[Today]",
  nextDay: "[Tomorrow]",
  nextWeek: "dddd, MMMM D, YYYY",
  lastDay: "[Yesterday]",
  lastWeek: "dddd, MMMM D, YYYY",
  sameElse: "dddd, MMMM D, YYYY",
};

export const MONTH_COMMA_DATE_COMMA_YEAR_FORMAT = "MMM, DD, YYYY";
